import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { getApiData, API_TYPES } from '@/utils/modelsApi';
import { rHandler } from '@/plugins/RHandler';
import { ROLES } from '@/constants/roles';

import Stage from '../list/stage';
import Team from '../list/team';
import Participant from '../list/participant';

const PRIVATE_ROLES = [ROLES.organization, ROLES.admin];

const API_DATA = {
  [API_TYPES.private]: {
    path: 'event-stages',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, Stage),

        getEventStageTeams({ args = [], params } = DEFAULT_PARAMS) {
          const [id] = args;
          return rHandler(
            apiService.get(`/${path}/${id}/teams`, params),
            (response) => ({
              response,
              items: response.data.data.map((i) => new Team(i, 'teams')),
            }),
            (error) => ({ error }),
          );
        },

        getEventStageMembers({ args = [], params } = DEFAULT_PARAMS) {
          const [id] = args;
          return rHandler(
            apiService.get(`/${path}/${id}/members`, params),
            (response) => ({
              response,
              items: response.data.data.map((i) => new Participant(i, 'members')),
            }),
            (error) => ({ error }),
          );
        },
      };
    },
  },
  [API_TYPES.public]: {
    path: 'public/event-stages',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, Stage),
      };
    },
  },
};

export const StageManager = {
  get objects() {
    return { ...getApiData(API_DATA, PRIVATE_ROLES).objects };
  },
};
